import carousel_1 from "./home_hero_carousel_1.webp";
import carousel_2 from "./home_hero_carousel_2.webp";
import carousel_3 from "./home_hero_carousel_3.webp";
import carousel_4 from "./home_hero_carousel_4.webp";
import carousel_5 from "./home_hero_carousel_5.webp";
import carousel_6 from "./home_hero_carousel_6.webp";
import carousel_7 from "./home_hero_carousel_7.webp";
import carousel_8 from "./home_hero_carousel_8.webp";
import carousel_9 from "./home_hero_carousel_9.webp";
import carousel_10 from "./home_hero_carousel_10.webp";
import carousel_11 from "./home_hero_carousel_11.webp";
import carousel_12 from "./home_hero_carousel_12.webp";
import carousel_13 from "./home_hero_carousel_13.webp";
import carousel_14 from "./home_hero_carousel_14.webp";
import carousel_15 from "./home_hero_carousel_15.webp";
import carousel_16 from "./home_hero_carousel_16.webp";
import carousel_17 from "./home_hero_carousel_17.webp";
import carousel_18 from "./home_hero_carousel_18.webp";
import carousel_19 from "./home_hero_carousel_19.webp";
import carousel_20 from "./home_hero_carousel_20.webp";
import carousel_21 from "./home_hero_carousel_21.webp";
import carousel_22 from "./home_hero_carousel_22.webp";
import carousel_23 from "./home_hero_carousel_23.webp";

export const carousel_images = [
  carousel_1,
  carousel_2,
  carousel_3,
  carousel_4,
  carousel_5,
  carousel_6,
  carousel_7,
  carousel_8,
  carousel_9,
  carousel_10,
  carousel_11,
  carousel_12,
  carousel_13,
  carousel_14,
  carousel_15,
  carousel_16,
  carousel_17,
  carousel_18,
  carousel_19,
  carousel_20,
  carousel_21,
  carousel_22,
  carousel_23,
];
